import React from "react";
import style from "./changepwd.module.css";
import { Modal, Form, Button, Input, message } from "antd";
import { ReactComponent as ChangePwdIcon } from "../../assets/icon/login/修改密码.svg";
import { useNavigate } from "react-router-dom";
import http from "../../utils/http";
function ChangePwdModalPwd({
  IsChangePwdModal,
  handCancelFn,
  setIsChangePwdModal,
}) {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const onFinish = (values) => {
    console.log(values);
    http.post('/api/users/changePwd/',values)
    .then(res=>{
        message.success(res.msg)
        navigate('/login')
        setIsChangePwdModal(false)
    })
    .catch(err=>{})
};
  return (
    <Modal
      width={700}
      open={IsChangePwdModal}
      onCancel={handCancelFn}
      footer={null}
    >
      <div className={style.ChangePwd_form}>
        <div className={style.ChangePwd_title}>
          <ChangePwdIcon width={30} />
          <p style={{ margin: "0 5px" }}>BioAIBP</p>
        </div>
        <Form
          form={form}
          onFinish={onFinish}
          style={{
            width: "90%",
            margin: "20px auto",
          }}
        >
          <Form.Item
            name="old_password"
            rules={[
              { required: true, message: "Please input your Old Password!" },
            ]}
          >
            <Input.Password placeholder="Please input new Old Password" />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[{ required: true, message: "Please input your Password!" }]}
          >
            <Input.Password placeholder="Please input new Password" />
          </Form.Item>
          <Form.Item
            name="confirm"
            dependencies={["password"]}
            hasFeedback
            rules={[
              {
                required: true,
                message: "Please confirm your Password!",
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error("The passwords entered twice do not match!")
                  );
                },
              }),
            ]}
          >
            <Input.Password placeholder="Confirm your Password" />
          </Form.Item>
          <Form.Item
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button
              type="primary"
              htmlType="submit"
              style={{
                background: "#46766A",
                color: "white",
                width: "250px",
              }}
            >
              Change Password
            </Button>
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
}

export default ChangePwdModalPwd;
